var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9357 3.06492C13.9594 2.0886 12.3765 2.0886 11.4002 3.06492L10.4839 3.98126C10.1584 4.30669 9.63079 4.30669 9.30535 3.98126C8.97991 3.65582 8.97991 3.12818 9.30535 2.80275L10.2217 1.8864C11.8489 0.259219 14.4871 0.259219 16.1142 1.8864C17.7414 3.51359 17.7414 6.15178 16.1142 7.77896L12.7809 11.1123C11.1537 12.7395 8.51554 12.7395 6.88836 11.1123C6.56292 10.7869 6.56292 10.2592 6.88836 9.93378C7.21379 9.60835 7.74143 9.60835 8.06687 9.93378C9.04318 10.9101 10.6261 10.9101 11.6024 9.93378L14.9357 6.60045C15.912 5.62414 15.912 4.04123 14.9357 3.06492ZM9.93574 8.06492C8.95942 7.0886 7.37651 7.0886 6.4002 8.06492L3.06687 11.3982C2.09056 12.3746 2.09056 13.9575 3.06687 14.9338C4.04318 15.9101 5.62609 15.9101 6.6024 14.9338L7.52037 14.0158C7.84581 13.6904 8.37345 13.6904 8.69888 14.0158C9.02432 14.3413 9.02432 14.8689 8.69888 15.1943L7.78091 16.1123C6.15373 17.7395 3.51554 17.7395 1.88836 16.1123C0.261173 14.4851 0.261173 11.8469 1.88836 10.2197L5.22169 6.8864C6.84888 5.25922 9.48706 5.25922 11.1142 6.8864C11.4397 7.21184 11.4397 7.73948 11.1142 8.06492C10.7888 8.39035 10.2612 8.39035 9.93574 8.06492Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e1f02aed07246e66ec4536057d3c0716.svg";
export { ForwardRef as ReactComponent };